import * as ko from "knockout";
import {nsSystemfields} from "../nsSystemfields";
import {IAvailableData, TColumnsConfig, TColumnsTranslation, TMode} from "./index";
import {isPartOf} from "../../../util/misc";
import {ISyncField} from "../../../index";
import {Table} from "./table";
import {ErrorManager} from "../../../error/ErrorManager";

export default abstract class Abstract {

    protected mode!: KnockoutObservable<TMode>
    protected readonly errorManager: ErrorManager;

    constructor(public syncfield: ISyncField, protected readonly availableData: IAvailableData, protected readonly table: Table) {
        this.errorManager = this.table.errorManager
    }

    abstract init(): void
    protected _uninit(keys: TColumnsConfig[] | TColumnsTranslation[]): void {
        const self = this as any;
        keys.forEach(key => {
            const errKey = 'err_' + key;
            self[errKey]?.dispose()
            this.errorManager.removeErrorObject(self[errKey])
            delete self[errKey]
            delete self[key]
        })
    }

    /*******************************************************************************************************************
     * View helpers
     ******************************************************************************************************************/

    protected getDef = nsSystemfields.getDef

    public isMode(...modes: TMode[]): boolean {
        return isPartOf<TMode>(this.mode(), ...modes)
    }

    abstract isChanged(): boolean

    abstract getSortValue(): string | number

    protected isFieldChanged(key: keyof ISyncField): boolean {
        switch(this.mode()) {
            case 'update': {
                const originalValue = this.syncfield[key];
                const ref = (this as any)[key];
                const newValue = ko.isObservable(ref) ? ref(): ref ?? originalValue;
                return newValue != originalValue
            }
            default: {
                return false
            }
        }
    }

}

